import { Fragment } from 'react'
import { DictionaryComponents } from '../../../../utils/globals/types'
import OrderEditProduct from '../OrderLayout/OrderTable/TableComponents/OrderEditProduct'
import InputTableLayout, { BigTitleAndRightLayoutInputTableNewCustomer, InputTableLayoutNew, InputTableLayoutProps } from '../../../../baseComponents/TwinTable/InputTableLayout'
import { connect, ConnectedProps } from 'react-redux'
import withLoading from '../../../../utils/hoc/withLoading'
import { AllReduxPayloads } from '../../../../utils/reducers'
import { ShippingCompanyPayload } from '../../../../utils/reducers/company/shippingCompanies'
import { ITDisplayPrice, ITDisplayFinalPrice, ITDisplayEditFinalPrice, ITDisplayImage, ITBooleanRender, ITDisplayPriceNotRounded, ITDisplayInitialPrice } from '../../../../baseComponents/TwinTable/InputTableLayout/InputTable/Components/Displays'
import { InputTableFooterFullProps } from '../../../../baseComponents/TwinTable/InputTableLayout/InputTable/types'
import { OrderCustomSelectBlockedItemsSearchbar, OrderEditableName, OrderEditableText, OrderInputCalendar, OrderInputDiscount, OrderInputPercentage, OrderInputPrice, OrderInputQuantity, OrderInputQuantity2, OrderRectangularInputSmall } from '../OrderLayout/OrderTable/TableComponents/Inputs'
import OrderSearchProductInput, { OrderSearchProductInputCreate, OrderSearchProductInputName, OrderSearchProductInputReferenceAndName } from '../OrderLayout/OrderTable/TableComponents/Inputs/OrderSearchProductInput'
import OrderEditAddonProduct from '../OrderLayout/OrderTable/TableComponents/OrderEditAddonProduct'
import { ITInputSelectWithSeachBar, ITInputSelectAccounts, ITInputSelectWarehouses } from '../../../../baseComponents/TwinTable/InputTableLayout/InputTable/Components/Inputs'
import { OrderDragHandle } from '../OrderLayout/OrderTable/TableComponents/Sorts'
import OrderTotal, { OrderTotalNew } from '../OrderLayout/OrderTotal'
import ModalsOrderSellLayout from '../OrderSellLayout/ModalsOrderSellLayout'
import { CostSellPayload } from '../../../../utils/reducers/company/costsSell'
import { getAllCostsSell, getUserPermissions } from '../../../../utils/reducers/getters'
import OrderUniqueNumberProduct, { OrderUniqueNumberProductReadOnly } from '../OrderLayout/OrderTable/TableComponents/OrderUniqueNumberProduct'
import { useOrderLayoutTableLogic } from '../OrderLayout/OrderTable/useOrderLayoutTableLogic'
import { permissionCheck } from '../../../../baseComponents/PermissionChecker/function'
import OrderSyncProductPrice from '../OrderLayout/OrderTable/TableComponents/OrderSyncProductPrice'
import { TwinDictionary } from '../../../../utils/globals/dictionary'
import OrderChangePackUnit from '../OrderLayout/OrderTable/TableComponents/OrdeChangePackUnit'
import OrderPrintTags from '../OrderLayout/OrderTable/TableComponents/OrderPrintTags'
import AppStyleDecider from '../../../../baseComponents/AppsStyleDecider'
import { FooterRowSellShortComponent } from '../OrderLayout/OrderTable/TableComponents/OrderTotal/Components/HeaderOrderTotal'
import { FooterConfigSellShippingComponent } from '../OrderLayout/OrderTotal/FooterOrderTotal/Components/FooterOrderLeftComponent'
import useOrderCalculateTotals from '../../../../utils/hooks/orders/useOrderCalculateTotals'

interface OrderQuoteLayoutProps extends InputTableLayoutProps {
     orderStatusDict: TwinDictionary
}

const OrderQuoteLayout: React.FC<OrderQuoteLayoutProps> = ({ ...rest }) => {
    return (
        <AppStyleDecider DefaultComponent={InputTableLayoutRenderDefault} NewComponent={InputTableLayoutRenderNew} {...rest} />
    )
}

const InputTableLayoutRenderDefault: React.FC<OrderQuoteLayoutProps> = ({...rest}) => {
    return (
        <InputTableLayout hookFunction={useOrderLayoutTableLogic} TableChildren={OrderTableChildren} {...rest} components={components} BigAndTitleRightLayout={BigTitleAndRightLayoutInputTableNewCustomer} />
    )
}

const InputTableLayoutRenderNew: React.FC<OrderQuoteLayoutProps> = ({...rest}) => {
    return (
        <InputTableLayoutNew hookFunction={useOrderLayoutTableLogic} TableChildren={OrderTableChildrenNew} {...rest} components={components} BigAndTitleRightLayout={BigTitleAndRightLayoutInputTableNewCustomer} />
    )
}

const OrderTableChildren: React.FC<InputTableFooterFullProps> = ({ completeData, CurrencyId, eventFunctions, customParseTableData, ...rest }) => {
    const costs = getAllCostsSell()
    const haveEditPermission = permissionCheck(getUserPermissions('quoteOther.updateQuoteTotalPrice'), 'read')
    const { totalsOrderTableData } = useOrderCalculateTotals({ completeData, customParseTableData })
    return (
        <Fragment>
            {!completeData?.header?.hidePrices ? <OrderTotal costs={costs || {}} {...{ completeData, CurrencyId, skipEdit: !haveEditPermission, ...rest }} totalsOrderTableData={totalsOrderTableData} /> : null}
            <ModalsOrderSellLayout headerData={completeData.header} deleteLine={eventFunctions.deleteLine} onChangeAdd={eventFunctions.onChangeAdd} onChangeFetch={eventFunctions.onChangeFetch} onChangeUpdate={eventFunctions.onChangeUpdate} completeData={completeData} totalsOrderTableData={totalsOrderTableData} {...rest} />
        </Fragment>
    )
}

const OrderTableChildrenNew: React.FC<InputTableFooterFullProps> = ({ completeData, CurrencyId, eventFunctions, customParseTableData,  ...rest }) => {
    const costs = getAllCostsSell()
    const haveEditPermission = permissionCheck(getUserPermissions('quoteOther.updateQuoteTotalPrice'), 'read')
    const { totalsOrderTableData } = useOrderCalculateTotals({ completeData, customParseTableData })
    return (
        <Fragment>
            {!completeData?.header?.hidePrices ? <OrderTotalNew costs={costs || {}} FooterOrderRowShortComponent={FooterRowSellShortComponent} FooterOrderLeftConfigComponent={FooterConfigSellShippingComponent} {...{ completeData, CurrencyId, skipEdit: !haveEditPermission, totalsOrderTableData, ...rest }} /> : null}
            <ModalsOrderSellLayout headerData={completeData.header} deleteLine={eventFunctions.deleteLine} onChangeAdd={eventFunctions.onChangeAdd} onChangeFetch={eventFunctions.onChangeFetch} onChangeUpdate={eventFunctions.onChangeUpdate} completeData={completeData} totalsOrderTableData={totalsOrderTableData} {...rest} />
        </Fragment>
    )
}

const components: DictionaryComponents = {
    ITRectangularInput: OrderRectangularInputSmall,
    ITEditableText: OrderEditableText,
    ITEditableName: OrderEditableName,
    ITInputNumeric: OrderInputPrice,
    ITInputPercentage: OrderInputPercentage,
    OrderSearchProductInput: OrderSearchProductInput,
    OrderSearchProductInputName: OrderSearchProductInputName,
    OrderSearchProductInputReferenceAndName: OrderSearchProductInputReferenceAndName,
    OrderSearchProductInputCreate: OrderSearchProductInputCreate,
    ITSelectSpecificPriceRule: OrderCustomSelectBlockedItemsSearchbar,
    ITInputQuantity: OrderInputQuantity,
    ITInputQuantity2: OrderInputQuantity2,
    ITInputDiscount: OrderInputDiscount,
    ITInputCalendar: OrderInputCalendar,
    ITDragHandle: OrderDragHandle,
    ITDisplayPrice: ITDisplayPrice,
    ITInputPrice: OrderInputPrice,
    ITDisplayPriceNotRounded: ITDisplayPriceNotRounded,
    ITDisplayFinalPrice: ITDisplayFinalPrice,
    ITDisplayEditFinalPrice: ITDisplayEditFinalPrice,
    ITDisplayInitialPrice,
    OrderEditProduct: OrderEditProduct,
    OrderSyncProductPrice,
    OrderEditAddonProduct: OrderEditAddonProduct,
    ITDisplayImage: ITDisplayImage,
    ITBooleanRender: ITBooleanRender,
    ITInputSelectAccounts: ITInputSelectAccounts,
    ITInputSelectWithSeachBar,
    OrderUniqueNumberProduct,
    OrderUniqueNumberProductReadOnly,
    ITInputSelectWarehouses,
    OrderChangePackUnit,
    OrderPrintTags,
}

const orderQuoteLayoutDispatch = {
    setShippingCompanies: (payload: ShippingCompanyPayload) => ({ type: 'CHANGE_SHIPPINGCOMPANY', payload }),
    setCostsSell: (payload: CostSellPayload) => ({ type: 'CHANGE_COSTSELL', payload }),
}

export type ReduxOrderQuoteLayout = ConnectedProps<typeof orderQuoteLayoutConnect>
const mapOrderQuoteLayoutConnector = (state: AllReduxPayloads) => ({ shippingCompanies: state.shippingCompanies, costsSell: state.costsSell })
const orderQuoteLayoutConnect = connect(mapOrderQuoteLayoutConnector, orderQuoteLayoutDispatch)
const orderQuoteLayoutConnectLoading = withLoading(OrderQuoteLayout, [{ fetchUrl: '/api/app/config/shipping/shippingCompany/getAllShippingCompaniesComplete', propName: 'shippingCompanies', setFunctionName: 'setShippingCompanies' }, { fetchUrl: '/api/app/config/cost/costSell/getAllCostSells', propName: 'costsSell', setFunctionName: 'setCostsSell' }])
const OrderQuoteLayoutConnect = orderQuoteLayoutConnect(orderQuoteLayoutConnectLoading)


export default OrderQuoteLayoutConnect